import styled from 'styled-components';
import {
  Form,
} from 'antd';
import { COLOR_WHITE } from 'constants/colors';
import { Button } from 'UI';

export const FormContainer = styled(Form)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 1.5rem;
  background-color: ${COLOR_WHITE};
`;

export const InlineButton = styled(Button)`
  display: inline-flex;
  width: auto;
`;

export const BaseFormItem = styled(Form.Item)`
  margin: 0;
  width: 100%;
  padding-bottom: 1.5rem;

  & .ant-col,
  & .ant-form-item-control {
    width: 100%;
  }
`;
